<form class="m-h-12 m-v-8"
  [formGroup]="form">
  <h3>{{ 'sigt.integration.rechercheGdf.form.recherche.titreCritereRecherche' | translate }}</h3>

  <mat-form-field class="d-flex tour-interactif-step-1-step-0">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.nom' | translate }}</mat-label>
    <input formControlName="nom"
      matInput
      class="form-control"
      maxlength="60">
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-1-step-1">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.prenom' | translate }}</mat-label>
    <input formControlName="prenom"
      matInput
      class="form-control"
      maxlength="60">
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-1-step-2">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.raisonSociale' | translate }}</mat-label>
    <input formControlName="raisonSociale"
      matInput
      class="form-control"
      maxlength="60">
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-1-step-3">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.codePostal' | translate }}</mat-label>
    <input formControlName="codePostal"
      matInput
      class="form-control"
      maxlength="6"
      placeholder="A9A9A9">
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-1-step-4">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.numeroTelephone' | translate }}</mat-label>
    <input formControlName="numeroTelephone"
      matInput
      class="form-control"
      maxlength="10"
      placeholder="9999999999"
      [appOnlyDigitAccepted]>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-1-step-5">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.typeDroit' | translate }}</mat-label>
    <mat-select formControlName="typeDroit"
      multiple
      (closed)="selectTypeDroitChanged()"
      appFilterableMatSelect>
      <mat-option *ngFor="let typDroit of typeDroitListeDeroulante"
        [value]="typDroit.typeDroit">
        {{typDroit.descriptionTypeDroit}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="form.controls.typeDroit.errors?.required">
      {{messageApplication.obligatoireTypeDroit}}
    </mat-error>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-1-step-6">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.fin' | translate }}</mat-label>
    <mat-select formControlName="fin"
      multiple
      (closed)="selectFinChanged()"
      appFilterableMatSelect>
      <mat-option *ngFor="let fin of finsListeDeroulante"
        [value]="fin.codeFin">
        {{fin.descriptionFin}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-1-step-7">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.statutDroit' | translate }}</mat-label>
    <mat-select formControlName="statutDroit"
      multiple
      (closed)="selectStatutChanged()">
      <mat-option *ngFor="let statut of statutListeDeroulante"
        [value]="statut.codeStatut">
        {{statut.nomStatut}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <h3>
    {{'sigt.integration.rechercheGdf.form.intervenantGdf.localisation'|translate}}<span class="required">*</span>
  </h3>

  <mat-form-field class="d-flex tour-interactif-step-1-step-8">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.municipalite' | translate }}</mat-label>
    <mat-select formControlName="municipalite"
      multiple
      appFilterableMatSelect>
      <mat-option *ngFor="let municipalite of municipaliteListeDeroulante"
        [value]="municipalite.codeMunicipalite">
        {{municipalite.nomMunicipalite}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-1-step-9">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.mrc' | translate }}</mat-label>
    <mat-select formControlName="mrc"
      multiple
      (closed)="selectMrcChange()"
      appFilterableMatSelect>
      <mat-option *ngFor="let mrc of mrcListeDeroulante"
        [value]="mrc.codeMrc">
        {{mrc.nomMrc}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="d-flex tour-interactif-step-1-step-10">
    <mat-label>{{ 'sigt.integration.rechercheGdf.form.intervenantGdf.regionAdmin' | translate }}</mat-label>
    <mat-select formControlName="regionAdministrative"
      multiple
      (closed)="selectRegionChange()"
      appFilterableMatSelect>
      <mat-option *ngFor="let regionAdministrative of regionsAdministrativeListeDeroulante"
        [value]="regionAdministrative.codeRegion">
        {{regionAdministrative.nomRegion}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <span [style.color]="couleurObligation"
    *ngIf="visibilite === true">
    {{ 'sigt.integration.rechercheGdf.form.intervenantGdf.champsObigatoire' | translate }}
  </span>

  <div class="boutons-en-grille">
    <button mat-raised-button
      type="button"
      class="clear-search-button tour-interactif-gdf-reinitialiser"
      (click)="initialiserChamps()">
      {{ 'sigt.global.boutons.reinitialiser' | translate }}
    </button>

    <button mat-raised-button
      class="search-button tour-interactif-gdf-rechercher"
      [disabled]="!form.valid"
      (click)="rechercher()"
      color="primary">
      {{ 'sigt.global.boutons.rechercher' | translate }}
    </button>
  </div>
</form>
